import React from "react";

import PropTypes from "prop-types";
import { Button } from "antd";
import {
  MessageOutlined
} from "@ant-design/icons";

const ReportButton = ({handleClick}) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Your other header content */}
      <div style={{ marginLeft: "auto" }}></div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <Button type="text" icon={<MessageOutlined  />} onClick={handleClick} />
        <span style={{ color: "#222", padding: "5px" }}>Report a problem</span>
      </div>
    </div>
  );
};

ReportButton.propTypes = {
  icon: PropTypes.element,
  isActive: PropTypes.bool,
  handleClick: PropTypes.func
};

export default ReportButton;
